import type { FaireProductEntity } from "../../entity_types/product";

export const p_xxuqf2gm9s: FaireProductEntity = {
  token: "p_xxuqf2gm9s",
  type: "product",
  name: "Gather Candle -LIMITED EDITION",
  brandToken: "b_rk82ea6pnc",
  brandName: "Smeli",
  imageUrl:
    "https://cdn.faire.com/fastly/bf70f258ae1086f10fae17d6ccf2580f5e24ee4c97d23164f3b65d6677ed205b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4afc9dd4157052fc7555e2b29874b677e339844d84e50b926860a316f3c6697.png",
  ],
  priceDollars: 14,
  description:
    "This is Gather. It's a 9 oz single wick candle in a black glass vessel, finished with our signature die cut illustrated label.\n\nWarm cinnamon and ginger melt into sugared almond and buttery pie crust, with nutmeg, allspice, clove, and soft vanilla lingering underneath. Rich, warm, and gently spiced, Gather feels like a table that's been set, something still warm from the oven, and everyone staying a little longer than planned.\n\nWarm. Spiced. Familiar.\n\nCinnamon | Ginger | Sugared Almond | Pie Crust | Vanilla\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:02.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
